// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_pi-0";
export var buttonContainer = "_pi-3";
export var cancelButton = "_pi-4";
export var headerSection = "_pi-6";
export var headerTitle = "_pi-9";
export var messageSideLeft = "_pi-1";
export var messageSideRight = "_pi-2";
export var orderNumberContainer = "_pi-7";
export var orderNumberLabel = "_pi-8";
export var submitButton = "_pi-5";